import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tab } from 'react-bootstrap';
import { getActionButtons, save } from '../../../../../src/web/store/modules/site';
import TabbedModal from '../../TabbedModal';
import FacilityUnitsColumnEditor from './FacilityUnitsColumnEditor';
import FacilityUnitsButtonEditor from './FacilityUnitsButtonEditor';
import FacilityUnitsPriceEditor from './FacilityUnitsPriceEditor';
import RentalAppEditor from './RentalAppEditor';

const propTypes = {
  actionButtons: PropTypes.shape({
    call: PropTypes.string.isRequired,
    moveIn: PropTypes.string.isRequired,
    reserve: PropTypes.string.isRequired,
  }).isRequired,
  columnHeadings: PropTypes.object.isRequired,
  facilitySettings: PropTypes.object.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  onFinishEdit: PropTypes.func.isRequired,
  saveSite: PropTypes.func.isRequired,
  tableTheme: PropTypes.string.isRequired,
  priceDisplay: PropTypes.object.isRequired,
  configDetails: PropTypes.object,
};

const defaultProps = {
  configDetails: undefined,
};

const getColumns = (headings, specials) => {
  const base = {};
  if (specials) {
    base.specials = 'Specials';
  }

  const columns = Object.assign(base, headings);
  return columns;
};

const Editor = ({
  actionButtons,
  columnHeadings,
  facilitySettings,
  onCancelEdit,
  onFinishEdit,
  saveSite,
  tableTheme,
  priceDisplay,
  configDetails,
}) => {
  const showSpecials = facilitySettings.enablePublicDescription;

  const [labels, setLabels] = useState({
    buttons: Object.assign({}, actionButtons),
    headings: getColumns(columnHeadings, showSpecials),
    priceDisplay: Object.assign({}, priceDisplay),
    configDetails: Object.assign({}, configDetails),
    initial: {
      buttons: Object.assign({}, actionButtons),
      headings: getColumns(columnHeadings, showSpecials),
      priceDisplay: Object.assign({}, priceDisplay),
      configDetails: Object.assign({}, configDetails),
    },
  });

  const handleChange = ({ type, key, value }) => {
    setLabels((oldLabels) => {
      const newLabels = Object.assign({}, oldLabels);
      newLabels[type][key] = value;
      return newLabels;
    });
  };

  const validateChange = ({ type, key }) => {
    const value = labels[type][key];
    return value && value.length > 0 ? null : 'error';
  };

  const facilityUnitsButtonEditor = (
    <FacilityUnitsButtonEditor
      buttons={labels.buttons}
      onChange={handleChange}
      validateChange={validateChange}
    />
  );

  const handleCancel = () => {
    setLabels((canceledLabels) => {
      const oldLabels = Object.assign({}, canceledLabels);
      oldLabels.buttons = oldLabels.initial.buttons;
      oldLabels.headings = oldLabels.initial.headings;
      oldLabels.priceDisplay = oldLabels.initial.priceDisplay;
      oldLabels.configDetails = oldLabels.initial.configDetails;
      return oldLabels;
    });
    onCancelEdit();
  };

  const handleSubmit = () => {
    saveSite({ actionButtons: labels.buttons }).then(() => {
      onFinishEdit({
        columnHeadings: labels.headings,
        priceDisplay: labels.priceDisplay,
        configDetails: labels.configDetails,
      });
      onCancelEdit();
    });
  };

  const themeThreeOrRentalApp = tableTheme === 'one' || tableTheme === 'two';

  return (
    <TabbedModal
      name="unitsTableEditor"
      onCancel={handleCancel}
      onSave={handleSubmit}
      title="Units Table Editor"
    >
      {themeThreeOrRentalApp
        && (
          <Tab title="Columns">
            <FacilityUnitsColumnEditor
              headings={labels.headings}
              onChange={handleChange}
              validateChange={validateChange}
            />
          </Tab>
        )}

        {tableTheme !== 'RentalApp' && (
          tableTheme !== 'three' ? <Tab title="Buttons">{facilityUnitsButtonEditor}</Tab> : facilityUnitsButtonEditor
        )}

        {tableTheme === 'RentalApp' ? (
          <RentalAppEditor
            configDetails={labels.configDetails}
            onChange={handleChange}
          />
        ) : null}

       {themeThreeOrRentalApp
        && (
            <Tab title="Price Display">
                    <FacilityUnitsPriceEditor
                      onPriceDisplayChange={handleChange}
                      priceDisplay={labels.priceDisplay}
                      tableTheme={tableTheme}
                    />
            </Tab>
        )}
    </TabbedModal>
  );
};

Editor.propTypes = propTypes;
Editor.defaultProps = defaultProps;

export default connect(
  state => ({
    actionButtons: getActionButtons(state),
  }),
  { saveSite: save },
)(Editor);
